import { Pipe, PipeTransform } from '@angular/core';
import { TxDocument } from '../../model/document.model';
import { checkMustSignRelation } from '../../utils/client-doc-relation.util';

@Pipe({
  name: 'checkMustSignRelation',
})
export class CheckMustSignRelationPipe implements PipeTransform {
  transform(document: TxDocument, clientId: string): boolean {
    return checkMustSignRelation(document, clientId);
  }
}
